import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import AiAvatarSpinner from '@/images/AiAvatarSpinner.svg';
import Magic from '@/images/Magic.svg';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ButtonBase } from '@mui/material';

const GenerateSkeletonContainer = styled.div`
    min-height: 48px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.secondary[900]};
    display: flex;
    justify-content: center;
    align-items: center;
`;

const rotate = keyframes`
  from {
    transform: rotate(360deg);
  }

  to {
    transform: rotate(0deg);
  }
`;

const GenerateSkeletonSpinner = styled.img`
    animation: ${rotate} 2s linear infinite;
`;

const StyledGenerateButton = styled(ButtonBase)`
    min-height: 48px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.secondary[900]};
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    gap: 8px;

    :disabled {
        background-color: ${({ theme }) => theme.colors.secondary[700]} !important;
    }
`;

interface Props {
    isLoading: boolean;
    disabled: boolean;
    onClick: () => void;
}

export const GenerateButton = ({ isLoading, disabled, onClick }: Props) => {
    if (isLoading) {
        return (
            <GenerateSkeletonContainer>
                <GenerateSkeletonSpinner src={AiAvatarSpinner} />
            </GenerateSkeletonContainer>
        );
    }

    return (
        <StyledGenerateButton data-testid="generate-ai-avatar-button" disabled={disabled} onClick={onClick}>
            <MaskedIcon src={Magic} size="24px" />
            Generate
        </StyledGenerateButton>
    );
};
